<template>
  <div>
    <h3 class="text-2xl max-w-2xl text-vice-teal-900 font-semibold leading-tight">
      Attendance per participants
    </h3>
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5 mb-10">
      <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead
          class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
        >
          <tr>
            <th scope="col" class="px-6 py-3">Name</th>
            <th scope="col" class="px-6 py-3">Role</th>
            <th scope="col" class="px-6 py-3">Status</th>
            <th scope="col" class="px-6 py-3">Present</th>
            <th scope="col" class="px-6 py-3">Proof of attendance</th>
            <!-- <th></th> -->
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="invitation in attendanceData"
            :key="invitation.name"
            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
          >
            <th
              scope="row"
              class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
            >
              {{ invitation.name }}
            </th>
            <td class="px-6 py-4">{{ invitation.role }}</td>
            <td class="px-6 py-4">
              {{ invitation.status }}
            </td>
            <td class="px-6 py-4">{{ invitation.present }}</td>
            <td class="px-6 py-4">
              <div class="flex flex-row justify-between items-center">
                <div class="flex flex-row">
                  <div v-if="invitation.proofOfAttendance.status === attendanceStatusPresent">
                    <ViceBadge small class="gb-blue text-blue mr-2">
                      {{ invitation.proofOfAttendance.status }}
                    </ViceBadge>
                  </div>

                  <div
                    v-else-if="
                      invitation.proofOfAttendance.status === attendanceStatusNeedsVerification
                    "
                  >
                    <ViceBadge small class="bg-amber-600 text-white mr-2">
                      {{ invitation.proofOfAttendance.status }}
                    </ViceBadge>
                  </div>

                  <div
                    v-else-if="invitation.proofOfAttendance.status === attendanceStatusNotPresent"
                  >
                    <ViceBadge small class="bg-red-600 text-white mr-2">
                      {{ invitation.proofOfAttendance.status }}
                    </ViceBadge>
                  </div>

                  <div v-if="invitation.proofOfAttendance.proofGenerated">
                    <ViceBadge small class="gb-blue text-blue">Proof generated</ViceBadge>
                  </div>
                </div>
                <div v-if="invitation.proofOfAttendance.markAsPresentLink">
                  <button
                    :href="invitation.proofOfAttendance.markAsPresentLink.url"
                    @click="
                      markAsPresent(
                        event,
                        invitation.proofOfAttendance.markAsPresentLink.session_id,
                        invitation.proofOfAttendance.markAsPresentLink.user_id,
                      )
                    "
                    class="
                      bg-white
                      hover:bg-gray-200
                      ring-gray-300 ring-1
                      rounded-sm
                      text-sm
                      px-2
                      py-1
                      focus:outline-none
                      text-gray-600
                    "
                  >
                    Mark as present
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ViceBadge from '@/Components/Badges/ViceBadge.vue';

export default {
  name: 'AttendancePerParticipants',
  props: {
    attendancePerParticipantsData: {
      require: true,
    },
  },
  components: {
    ViceBadge,
  },
  created() {
    this.getAttendanceData();
  },
  data() {
    return {
      attendanceData: [],
      attendanceStatusPresent: 'Present',
      attendanceStatusNotPresent: 'Not present',
      attendanceStatusNeedsVerification: 'Needs verification',
    };
  },
  methods: {
    async markAsPresent(event, sessionId, userId) {
      const requestData = {
        session_id: sessionId,
        user_id: userId,
      };

      const response = await axios.post(route('session.clinician.mark-as-present'), requestData);

      this.attendanceData = await response.data;
    },
    async getAttendanceData() {
      const response = await axios.get(route('get-attendance-data', this.$page.props.session.id));
      this.attendanceData = response.data;
    },
  },
};
</script>

<style scoped>
.bg-amber-600 {
  background-color: #ea580c;
}

.gb-blue {
  background-color: #99f6e4;
}

.text-blue {
  color: #5a1bb5;
}

.icon-color {
  color: #727373;
}
</style>
